tenderView.controller('tenderViewComplaintPostCtrl', (
    $rootScope,
    $scope,
    $uibModalInstance,
    $uibModal,
    $state,
    tenderService,
    complaintService,
    data,
    ntFlash,
    $timeout
) => {
    $scope.complaint = data.complaint
    $scope.post = data.post
    $scope.tenderId = data.tenderId
    $scope.awardId = data.complaint.awardId
    $scope.qualificationId = data.complaint.qualificationId
    $scope.cancellationId = data.complaint.cancellationId
    $scope.objections = data.complaint.objections
    $scope.postId = ($scope.post) ? $scope.post.id : null
    $scope.author = data.author
    $scope.posts = {
        title: "",
        description: "",
        author: $scope.author ? "tender_owner" : "complaint_owner",
        relatedObjection: $scope.complaint.objections[0].id
    }


    if($scope.postId){
        $scope.posts.relatedPost = $scope.postId
        $scope.posts.recipient = $scope.post.author
    }

    $scope.sendComplaintPost = () => {
        complaintService.createPosts(data.tenderId, $scope.posts, $scope.complaint.id, $scope.awardId, $scope.qualificationId, $scope.cancellationId)
            .then((data)=> {
                console.log('complaintService.create data', data);
                $timeout(() => {
                    $state.go('tenderView.complaint', {}, {
                        reload: true
                    });
                    $uibModalInstance.close();
                }, 500);
            })
            .catch((error) => {
                console.log('complaintService.create error', error);
                ntFlash.error(gettext('Сталася помилка'));
                $uibModalInstance.close();
            });


        console.log($scope.posts)
    }




})
